import BlockchainAnalyticsSubHeader from './AICatalystSubHeader'

export default BlockchainAnalyticsSubHeader
